import type {
  IntegrationCredential,
  IntegrationCredentialUpdate,
} from "@/schemas/integration-credentials.schema";
import { api } from "@/services/api";

export const integrationApi = {
  async get() {
    const { data } = await api<IntegrationCredential[]>("/integration-credentials");

    return data;
  },

  async add(data: IntegrationCredentialUpdate) {
    await api.post("/integration-credentials", data);
  },

  async remove(id: string) {
    await api.delete(`/integration-credentials/${id}`);
  },

  async update(id: string, data: IntegrationCredentialUpdate) {
    await api.patch(`/integration-credentials/${id}`, data);
  },
};
